// extracted by mini-css-extract-plugin
module.exports = {"gsapBText1":"gsapBText1_gsapBText1__TlNrg"};